import { IDayOfTheWeekValue, IDayOfTheWeekEnum } from 'utility-js-time';
import { IEnumeratedSetContract, IEnumeratedSetValueDatatype } from 'utility-js-enumeration';

angular.module('ui-ng-calendar').factory('getDayEnums', function getDayEnums(DayOfTheWeekEnum: IDayOfTheWeekEnum) {
  return function (includeWeekends: string, microheaders: string): Object {
    const filterDayColumns = function filterDayColumns(
      days: Object[],
      filteredIncludeWeekends: string,
      useMicroname: string
    ) {
      return _.map(
        _.filter(days, function (day: any) {
          return (filteredIncludeWeekends === 'false' && (day.key === 'su' || day.key === 'sa')) || day.key === 'online'
            ? false
            : true;
        }),
        function (day) {
          if (useMicroname === 'true') {
            return {
              id: day.id,
              name: day.value.microname
            };
          }

          return {
            id: day.id,
            name: day.value.shortname
          };
        }
      );
    };

    return {
      dayOfTheWeek: DayOfTheWeekEnum,
      days: filterDayColumns(_.toArray(DayOfTheWeekEnum.iterator()), includeWeekends, microheaders),
      allDays: _.filter(DayOfTheWeekEnum.iterator(), function (day: IDayOfTheWeekValue) {
        return !DayOfTheWeekEnum.isEqual(day, DayOfTheWeekEnum.ONLINE as IEnumeratedSetValueDatatype);
      })
    };
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/functions/get_day_enums.ts